import { useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface MarkdownRendererProps {
  content: string;
}

export function MarkdownRenderer({ content }: MarkdownRendererProps) {
  const sanitizedContent = useMemo(() => content, [content]);

  return (
    <div className="prose prose-sm max-w-none prose-headings:font-semibold prose-headings:text-ds-text prose-p:text-ds-text prose-li:text-ds-text prose-strong:text-ds-text prose-h1:text-3xl prose-h2:text-2xl prose-h3:text-xl prose-h4:text-lg prose-a:text-ds-teal hover:prose-a:text-ds-teal-700 prose-code:text-ds-teal prose-pre:bg-ds-sunk prose-pre:text-ds-text prose-img:rounded-lg">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{sanitizedContent}</ReactMarkdown>
    </div>
  );
}
